import { useContext } from "react"
import { ContentPage } from "../../components/contentful"
import { getPageContents } from "../../components/contentful/pageProps"
import { OetContext } from "../../context"

const OnlineEstimator = ({ content, preview }) => {
    const { state } = useContext(OetContext)

    return (
        <ContentPage
            {...{
                content,
                context: {
                    estimateAmount: state?.estimateAmount,
                },
                preview,
            }}
        />
    )
}

export async function getStaticProps({ ...props }) {
    return await getPageContents(props, {
        type: "page",
        filterField: "fields.slug",
        filterValue: "online-estimator",
    })
}

export default OnlineEstimator
